import * as React from 'react';

type TagIconProps = React.SVGProps<SVGSVGElement>;

export const TagIcon: React.FC<TagIconProps> = React.memo(({ height = 20, width = 20, ...props }) => {
    return (
        <svg
            viewBox='0 0 24 24'
            width={width}
            height={height}
            fill='none'
            stroke='currentColor'
            strokeWidth='1.75'
            strokeLinecap='round'
            strokeLinejoin='round'
            xmlns='http://www.w3.org/2000/svg'
            style={{ color: '#1a1a1a' }}
            {...props}
        >
            <path d='M3 3h7.5l9.2 9.2a2 2 0 0 1 0 2.83l-4.2 4.2a2 2 0 0 1-2.83 0L3 10V3z'></path>
            <circle cx='8' cy='8' r='1.5' fill='currentColor' stroke='none'></circle>
        </svg>
    );
});
